var getRaizSesiones = function getRaizSesiones(state) {
  return state.sesiones;
};

export var getSesiones = function getSesiones(state) {
  return getRaizSesiones(state).sesiones;
};
export var getSesionActiva = function getSesionActiva(state, id) {
  return getRaizSesiones(state).sesiones.find(function (sesion) {
    return sesion.id === id;
  });
};
export var getIdSesionActiva = function getIdSesionActiva(state) {
  return getRaizSesiones(state).idSesionActiva;
};
export var getIdUltimaSesionActiva = function getIdUltimaSesionActiva(state) {
  return getRaizSesiones(state).idUltimaSesionActiva;
};